module.exports = __webpack_public_path__ + "static/media/location-maps-letter-a-arrow.0d433138.png";